(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getFeedId(mount) {
    const configured = mount.getAttribute('data-feed-id');
    if (configured !== null && configured !== '') {
      const parsed = parseInt(configured, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    }

    const feedEl = mount.querySelector('[id^="feed-"]');
    if (feedEl) {
      const match = feedEl.id.match(/^feed-(\d+)$/);
      if (match) return parseInt(match[1], 10);
    }

    return 0;
  }

  function hasSlider(mount, feedId) {
    const prefix = feedId === 0 ? 'instafeed' : 'feed-' + feedId;
    return Boolean(
      mount.querySelector('.' + prefix + '-new-arrow-next') ||
        mount.querySelector('.' + prefix + '-new-layout-container') ||
        mount.querySelector('.instafeed-carousel-arrow')
    );
  }

  function startAutoplay(mount) {
    if (prefersReducedMotion()) return;
    if (mount.dataset.autoplayStarted === 'true') return;
    if (typeof window.instafeedSliderMove !== 'function') return;

    const feedId = getFeedId(mount);
    if (!hasSlider(mount, feedId)) return;

    const intervals = window.instafeedScrollIntervals || {};
    if (intervals[feedId]) return;

    const speed = parseInt(mount.getAttribute('data-autoplay-speed') || '5000', 10);
    mount.dataset.autoplayStarted = 'true';

    let timer = null;

    const tick = function () {
      if (typeof window.instafeedSliderMove === 'function') {
        window.instafeedSliderMove(1, feedId);
      }
    };

    const start = function () {
      if (timer) window.clearInterval(timer);
      timer = window.setInterval(tick, speed);
    };

    const stop = function () {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    start();
    mount.addEventListener('mouseenter', stop);
    mount.addEventListener('mouseleave', start);
    mount.addEventListener('focusin', stop);
    mount.addEventListener('focusout', start);
    mount.addEventListener('touchstart', stop, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('.instagram-feed__instafeed-mount[data-autoplay-enabled="true"]').forEach(function (mount) {
      startAutoplay(mount);
    });
  }

  document.addEventListener('instafeedAppLoaded', function () {
    window.setTimeout(initAll, 300);
  });

  window.addEventListener('load', function () {
    window.setTimeout(initAll, 1200);
  });
})();
